import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String], $for_admin: Int) {
        shop(ids: $ids, for_admin: $for_admin) {
          data {
            management_info
          }
        }
      }
    `,
  },
  update: {
    name: 'updateShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateShop($ids: [String]!, $management_info: String) {
        updateShop(ids: $ids, management_info: $management_info) {
          messages
        }
      }
    `,
  },
  sync: {
    name: 'syncAllProductShopQueue',
    serviceName: 'shopadmin',
    query: gql`
      mutation syncAllProductShopQueue(
        $shop_id: String!
        $update_type: String
        $currency: String
        $is_active: Int
        $update_n_m: Int
      ) {
        syncAllProductShopQueue(
          shop_id: $shop_id
          update_type: $update_type
          currency: $currency
          is_active: $is_active
          update_n_m: $update_n_m
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
